/*actions*/
export const Adicionar = 'AdicionarMaterial';
export const AdicionarMaterial = 'AdicionarMaterial';
export const AdicionarBlocos = 'AdicionarBlocos';
export const ApagarBlocos = 'ApagarBlocos';
export const EditarBlocos = 'EditarBlocos';
export const AdicionarNaoConformidade = 'AdicionarNaoConformidade';
export const Editar = 'EditarMaterial';
export const Apagar = 'ApagarMaterial';
export const JustificativaCancelamento = 'JustificativaCancelamento';
export const EntregaResultadoExames = 'EntregaResultadoExames';
export const FiltroGrupoUsuario = 'FiltroGrupoUsuario';
export const Filtrar = 'FiltrarLaudo';
export const Rastreabilidade = 'Rastreabilidade';
export const Recolhimento = 'Recolhimento';
//export const DelegacaoLaminas = 'DelegacaoLaminas';
export const RequisicaoImuno = 'RequisicaoImuno';
export const FaturarLaudo = 'FaturarLaudo';
export const CancelamentoMATERIAL = 'CancelamentoMATERIAL';
export const CancelamentoCish = 'CancelamentoCISH';
export const CancelamentoConclusao = 'CancelamentoCONCLUSAO';
export const CancelamentoCongelacao = 'CancelamentoCONGELACAO';
export const CancelamentoFish = 'CancelamentoFISH';
export const CancelamentoHisto = 'CancelamentoHISTO';
export const CancelamentoImuno = 'CancelamentoIMUNO';
export const CancelamentoPcr = 'CancelamentoPCR';
export const CancelamentoErrata = 'CancelamentoERRATA';
export const CancelamentoMacro = 'CancelamentoMACRO';
export const CancelamentoMicro = 'CancelamentoMICRO';
export const CancelamentoNotas = 'CancelamentoNOTAS';
export const DescarteMateriais = 'DescarteMateriais';
export const ConsultaDescarteMateriais = 'ConsultaDescarteMateriais';
export const AlterarMedicoExecutanteRevisor = 'AlterarMedicoExecutanteRevisor';
export const ReceberMaterial = 'ReceberMaterial';
export const AcessoTotalSistema = 'AcessoTotalSistema';
// Etapas
export const Cish = 'Cish';
export const Errata = 'Errata';
export const Fish = 'Fish';
export const Imuno = 'Imuno';
export const Notas = 'Notas';
export const Pcr = 'Pcr';
export const Macroscopia = 'Macroscopia';
export const Microscopia = 'Microscopia';
export const Histoquimica = 'Histoquimica';
export const Congelacao = 'Congelacao';
export const Conclusao = 'Conclusao';
/*pages*/
export const RecebimentoMaterial = 'RecebimentoMaterial';
export const NaoConformidades = 'NaoConformidades';
export const RastrearLaudo = 'RastrearLaudo';
export const Laudos = 'Laudos';
export const Faturar = 'Faturar';
export const Cassetes = 'Blocos';
export const Web = 'Web';
/*não mapeadas na API*/
export const Resolver = 'Resolver';
export const Imprimir = 'Imprimir';
export const Concluir = 'Concluir';
export const ConcluirPendente = 'ConcluirPendente';
export const ConcluirConferencia = 'ConcluirConferencia';
export const ExamesEmAberto = 'ExamesEmAberto';
export const VincularExame = 'VincularExame';
export const Etiqueta = 'Etiqueta';
export const Anexo = 'Anexo';
export const DocExterno = 'DocExterno';
export const MultiplosExames = 'MultiplosExames';
export const Faturamento = 'Faturamento';
export const MedicoDesignado = 'MedicoDesignado';
export const DataPrevistaEntrega = 'DataPrevistaEntrega';
export const AutoTexto = 'AutoTexto';
export const ListaFrasco = 'ListaFrasco';
export const ListaLaminas = 'ListaLaminas';
export const LaudosAnteriores = 'LaudosAnteriores';
export const HistoricoLaudo = 'HistoricoLaudo';
export const RequisicaoProtocolo = 'RequisicaoProtocolo';
export const TopografiaMorfologia = 'TopografiaMorfologia';

// Novos
export const RelatorioAnticorposCadastrados = 'RelatorioAnticorposCadastrados'; //Relatório de anticorpos cadastrados (Anticorpos)
export const EditarFrasco = 'EditarFrasco'; // Alteração de registros (Frascos)
export const ApagarFrasco = 'ApagarFrasco'; // Exclusão de registros (Frascos)
export const AdicionarFrasco = 'AdicionarFrasco'; // Inclusão de novos registros (Frascos)
export const ManutencaoCadastroFrasco = 'ManutencaoCadastroFrasco'; // Manutençao de cadastro de Frascos (Frascos)
export const EditarBandeja = 'EditarBandeja'; // Alteração de registros (Bandejas)
export const ApagarBandeja = 'ApagarBandeja'; // Exclusão de registros (Bandejas)
export const AdicionarBandeja = 'AdicionarBandeja'; //Inclusão de novos registros (Bandejas)
export const ManutencaoCadastroBandeja = 'ManutencaoCadastroBandeja'; //Manutençao de cadastro de bandejas (Bandejas)
export const RelatorioBandejas = 'RelatorioBandejas'; //Relatório de bandejas cadastradas (Bandejas)
export const ManutencaoCadastroBlocos = 'ManutencaoCadastroBlocos'; //Manutençao de cadastro de blocos (Blocos)
export const RelatorioBlocosCadastrados = 'RelatorioBlocosCadastrados'; //Relatório de blocos cadastrados (Blocos)
export const EditarCestas = 'EditarCestas'; //Alteração de registros (Cestas)
export const ApagarCestas = 'ApagarCestas'; //Exclusão de registros (Cestas)
export const AdicionarCestas = 'AdicionarCestas'; //Inclusão de novos registros (Cestas)
export const ManutencaoCadastroCestas = 'ManutencaoCadastroCestas'; //Manutençao de cadastro de cestas (Cestas)
export const RelatorioCestasCadastradas = 'RelatorioCestasCadastradas'; //Relatório de cestas cadastradas (Cestas)
export const EditarBlocoseLaminasAreaTecnica =
	'EditarBlocoseLaminasAreaTecnica'; //Alteração de registros ( de Blocos e Lâminas - Área tecnica)
export const ApagarBlocoseLaminasAreaTecnica =
	'ApagarBlocoseLaminasAreaTecnica'; //Exclusão de registros ( de Blocos e Lâminas - Área tecnica)
export const AdicionarBlocoseLaminasAreaTecnica =
	'AdicionarBlocoseLaminasAreaTecnica'; //Inclusão de novos registros ( de Blocos e Lâminas - Área tecnica)
export const EditarBlocoseLaminasCitologia = 'EditarBlocoseLaminasCitologia'; //Alteração de registros ( de Blocos e Lâminas - Citologia)
export const ApagarBlocoseLaminasCitologia = 'ApagarBlocoseLaminasCitologia'; //Exclusão de registros ( de Blocos e Lâminas - Citologia)
export const AdicionarBlocoseLaminasCitologia =
	'AdicionarBlocoseLaminasCitologia'; //Inclusão de novos registros ( de Blocos e Lâminas - Citologia)
export const EditarBlocoseLaminasCongelacao = 'EditarBlocoseLaminasCongelacao'; //Alteração de registros ( de Blocos e Lâminas - Congelação)
export const ApagarBlocoseLaminasCongelacao = 'ApagarBlocoseLaminasCongelacao'; //Exclusão de registros ( de Blocos e Lâminas - Congelação)
export const AdicionarBlocoseLaminasCongelacao =
	'AdicionarBlocoseLaminasCongelacao'; //Inclusão de novos registros ( de Blocos e Lâminas - Congelação)
export const EditarBlocoseLaminasMapaMacroscopico =
	'EditarBlocoseLaminasMapaMacroscopico'; //Alteração de registros ( de Blocos e Lâminas - Mapa macroscópico)
export const ApagarBlocoseLaminasMapaMacroscopico =
	'ApagarBlocoseLaminasMapaMacroscopico'; //Exclusão de registros ( de Blocos e Lâminas - Mapa macroscópico)
export const AdicionarBlocoseLaminasMapaMacroscopico =
	'AdicionarBlocoseLaminasMapaMacroscopico'; //Inclusão de novos registros ( de Blocos e Lâminas - Mapa macroscópico)
export const DelegacaoBlocos = 'DelegacaoBlocos'; //Delegação de blocos (Delegação de blocos)
export const DelegacaoLaminas = 'DelegacaoLaminas'; //Delegação de lâminas (Delegação de lâminas)
export const ListaTarefasParaCitologia = 'ListaTarefasParaCitologia'; //Lista de tarefas para citologia (Lista de tarefas)
export const ListaTarefasParaEtapasLaudo = 'ListaTarefasParaEtapasLaudo'; //Lista de tarefas para etapas do laudo (Lista de tarefas)
export const AdicionarListadetarefas = 'AdicionarListadetarefas'; //Lista de tarefas para histotécnica - Inclusão (Lista de tarefas)
export const ListaTarefasParaHistotecnicaLamina =
	'ListaTarefasParaHistotecnicaLamina'; //Lista de tarefas para histotécnica - Lâmina (Lista de tarefas)
export const ListaTarefasParaImunologia = 'ListaTarefasParaImunologia'; //Lista de tarefas para imunologia (Lista de tarefas)
export const ListaTarefasParaImunologiaImprimirGestaoAmostras =
	'ListaTarefasParaImunologiaImprimirGestaoAmostras'; //Lista de tarefas para imunologia - Imprimir gestão de amostras (Lista de tarefas)
export const ListaTarefasParaImunologiaImprimirRequisicao =
	'ListaTarefasParaImunologiaImprimirRequisicao'; //Lista de tarefas para imunologia - Imprimir Requisição (Lista de tarefas)
export const EditarMorfologias = 'EditarMorfologias'; //Alteração de registros (Morfologias)
export const ApagarMorfologias = 'ApagarMorfologias'; //Exclusão de registros (Morfologias)
export const AdicionarMorfologias = 'AdicionarMorfologias'; //Inclusão de novos registros (Morfologias)
export const ManutencaoCadastroDiagnosticos = 'ManutencaoCadastroDiagnosticos'; //Manutenção de cadastro de diagnósticos (Morfologias)
export const RelatorioDiagnosticosCadastrados =
	'RelatorioDiagnosticosCadastrados'; //Relatório de diagnósticos cadastrados (Morfologias)
export const DeletarRegistroAuditoria = 'DeletarRegistroAuditoria'; //Deletar registro de auditoria (Auditoria)
export const MonitoramentoAuditoria = 'MonitoramentoAuditoria'; //Monitoramento de auditoria (Auditoria)
export const RelatorioAuditoria = 'RelatorioAuditoria'; //Relatório de auditoria (Auditoria)
export const CancelamentoArquivamentoBlocosELaminas =
	'CancelamentoArquivamentoBlocosELaminas'; // Cancelamento de arquivamento de blocos e lâminas (Cancelamento de arquivamento de blocos e lâminas)
export const ConsultaArquivamentoBlocosELaminas =
	'ConsultaArquivamentoBlocosELaminas'; // Consulta de arquivamento de blocos e lâminas (Consulta arquivamento de blocos e lâminas)
export const ConsultaMovimentoArquivoBlocosELaminas =
	'ConsultaMovimentoArquivoBlocosELaminas'; // Consulta do movimento de arquivo de blocos e lâminas (Consulta do movimento de arquivo de blocos e lâminas)
export const ConsultaRequisicaoBlocosELaminas =
	'ConsultaRequisicaoBlocosELaminas'; // Consulta de requisição de blocos e lâminas (Consulta requisição de blocos e lâminas)
export const RequisicaoEDevolucaoBlocosELaminas =
	'RequisicaoEDevolucaoBlocosELaminas'; // Requisição e devolução de blocos e lâminas (Rastrear laudos)
export const LiberarLaudoParaEntrega = 'LiberarLaudoParaEntrega'; // Permissão para Libera laudo para entrega
export const ConfiguracaoPreferenciasUsuario =
	'ConfiguracaoPreferenciasUsuario'; // Configuração de preferências do usuário (Preferências do usuário)
export const CertificacaoDigital = 'CertificacaoDigital'; // Configuração de Certificação Digital
export const ReabrirEtapaMaterial = 'ReabrirEtapaMaterial'; // Reabrir etapa material



// WEBPACK FOOTER //
// ./src/acessos.const.util.js